module.exports = __webpack_public_path__ + "img/50.b83ad982.png";